export default {
  SET_BLOG_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  SET_BLOG(state, payload) {
    state.blogs = payload;
  },
};
